import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseAdvanceMaintenanceDirectiveExecutionEntryProps {
  directiveEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useAdvanceMaintenanceDirectiveExecutionEntry = ({
  directiveEntryId,
  options,
}: UseAdvanceMaintenanceDirectiveExecutionEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['advanceMaintenanceDirectiveExecutionEntry'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/directive/execution_entries/${directiveEntryId}/advance`)
    },
    ...options,
  })
}
